<template>
    <div class="login-language-selector">
        <div class="language-dropdown-wrapper">
            <div class="dropdown">
                <button class="btn btn-link dropdown-toggle language-btn" 
                        type="button" 
                        id="loginLanguageDropdown" 
                        data-toggle="dropdown" 
                        aria-haspopup="true" 
                        aria-expanded="false">
                    <span class="language-flag">🌐</span>
                    <span class="language-text">{{ currentLanguageName }}</span>
                </button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="loginLanguageDropdown">
                    <a class="dropdown-item" 
                       v-for="language in languages" 
                       :key="language.key" 
                       :href="language.url"
                       :class="{ active: language.key === currentLanguage }">
                        <div class="d-flex align-items-center justify-content-center">
                            <h6 class="mb-0 font-weight-normal">{{ language.title }}</h6>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LoginLanguageSelector",
    props: {
        languages: {
            type: Array,
            required: true,
            default: () => []
        },
        currentLanguage: {
            type: String,
            default: 'en'
        }
    },
    computed: {
        currentLanguageName() {
            const currentLang = this.languages.find(lang => lang.key === this.currentLanguage);
            return currentLang ? currentLang.title : 'English';
        }
    }
}
</script>

<style scoped>
.login-language-selector {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1000;
}

.language-dropdown-wrapper {
    .dropdown {
        .language-btn {
            background: rgba(255, 255, 255, 0.9);
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            padding: 8px 16px;
            color: #495057;
            text-decoration: none;
            font-size: 0.875rem;
            font-weight: 500;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            gap: 8px;
            min-width: 120px;
            justify-content: space-between;
        }

        .language-btn:hover {
            background: rgba(255, 255, 255, 1);
            color: #007bff;
            text-decoration: none;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
            transform: translateY(-1px);
        }

        .language-btn:focus {
            outline: none;
            box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
        }

        .language-flag {
            font-size: 1.1rem;
        }

        .language-text {
            flex: 1;
            text-align: left;
        }

        .dropdown-menu {
            min-width: 150px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            padding: 0.5rem 0;
            margin-top: 8px;
            background: white;

            .dropdown-item {
                padding: 0.75rem 1.5rem;
                color: #495057;
                text-decoration: none;
                transition: all 0.2s ease;
                border: none;
                background: none;
                width: 100%;
                text-align: left;

                &:hover {
                    background-color: #f8f9fa;
                    color: #007bff;
                }

                &.active {
                    background-color: #007bff;
                    color: white;
                    font-weight: 600;
                }

                h6 {
                    margin: 0;
                    font-size: 0.875rem;
                }
            }
        }
    }
}

/* RTL Support */
[dir="rtl"] .login-language-selector {
    right: auto;
    left: 20px;
}

[dir="rtl"] .language-btn {
    .language-text {
        text-align: right;
    }
}

[dir="rtl"] .dropdown-menu {
    right: auto;
    left: 0;
}

[dir="rtl"] .dropdown-item {
    text-align: right;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
    .login-language-selector {
        top: 15px;
        right: 15px;
    }

    .language-dropdown-wrapper .dropdown .language-btn {
        padding: 6px 12px;
        font-size: 0.8rem;
        min-width: 100px;
    }

    .language-dropdown-wrapper .dropdown .language-flag {
        font-size: 1rem;
    }
}
</style>
